import { formatBalance } from '@ui/src';
import { useAppSelector } from '@store';
import { ProfitLossFrsRowTypes } from './types';

import cn from './profit-loss.module.css';

const ProfitLossFrsRow = ({ title, amount, bold }: ProfitLossFrsRowTypes) => {
  const { baseCurrency } = useAppSelector((state) => state.reportsDictionaries);

  return (
    <div
      className={`${cn.profitLossFrsRow} ${
        bold ? cn.profitLossFrsRowBold : ''
      }`}
    >
      <div className={cn.profitLossFrsRowValue}>{title}</div>
      <div className={cn.profitLossFrsRowValue}>
        {amount !== undefined
          ? formatBalance(amount as unknown as number, baseCurrency)
          : ''}
      </div>
    </div>
  );
};

export default ProfitLossFrsRow;
